export default __webpack_public_path__ + "static/media/thumb-Marine-Receiver-6.996f6580.png";